"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHex = void 0;
var hexChars = Object.freeze(Array.from("0123456789abcdef"));
function isHex(str) {
    if (!(typeof str === "string"))
        return false;
    return Array.from(str).every(function (ch) { return hexChars.includes(ch); });
}
exports.isHex = isHex;
